import {Autocomplete, Paper, TextField} from '@mui/material'
import {TFunction} from 'i18next'
import React, {useEffect} from 'react'

import {WorkCenter} from '@hconnect/common/types'

const paper = (props) => <Paper elevation={8} style={{minWidth: '350px'}} {...props} />

export type WorkCenterSearchHierarchyProps = {
  label?: React.ReactNode
  errorText?: React.ReactNode
  t: TFunction
  onChange: (workCenter: WorkCenter | undefined) => void
  workCenters: WorkCenter[]
  value: WorkCenter | undefined
  required?: boolean
}
export const WorkCenterSearchHierarchy = (props: WorkCenterSearchHierarchyProps) => {
  const [open, setOpen] = React.useState<boolean>(false)

  const [inputValue, setInputValue] = React.useState<string>('')
  const options = props.workCenters

  const value = props.value?.text

  useEffect(() => {
    setInputValue(value ?? '')
  }, [value])

  return (
    <Autocomplete
      data-test-id="work-center-search"
      value={props.value ?? null}
      inputValue={inputValue}
      open={open && options.length > 0}
      onOpen={() => {
        setOpen(true)
      }}
      onChange={(_event, next, reason) => {
        if (reason === 'clear') {
          setInputValue('')
          props.onChange(undefined)
          return
        }
        if (next && typeof next !== 'string') {
          props.onChange(next)
        }
      }}
      onClose={() => {
        setOpen(false)
      }}
      onInputChange={(_event, newValue, reason) => {
        if (reason === 'input' && newValue !== inputValue) {
          setInputValue(newValue)

          if (!newValue && props.value) {
            props.onChange(undefined)
          }
        }
      }}
      options={options}
      getOptionLabel={(workCenter) => workCenter.text}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            error={!!props.errorText}
            data-test-id="work-center-search-input"
            helperText={props.errorText}
            label={props.t('label.workCenterInput')}
            required={props.required}
            placeholder={props.t('pleaseStartTyping')}
            variant="filled"
          />
        )
      }}
      PaperComponent={paper}
      forcePopupIcon={false}
    />
  )
}
